import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bemGenerator } from '@prisjakt/ui-base';

import StoreLogo, { VARIANTS as LOGO_VARIANTS } from '@prisjakt/ui-store-logo';

import './index.scss';

const styles = bemGenerator('soty-winner-card', [
  'logo',
  'content',
  'award-name',
  'winner-link',
]);

const WinnerCard = ({ award, winner, featured }) => (
  <div className={styles.block.withModifier({ featured })}>
    <img className={styles.logo} src={award.logo} alt="" />
    <div className={styles.content}>
      <h2 className={styles['award-name']}>{award.name}</h2>
      <Link className={styles['winner-link']} to={winner.pathName}>
        <StoreLogo
          variant={LOGO_VARIANTS.SOTY}
          name={winner.name}
          storeId={winner.id}
          hasImage={winner.hasLogo}
        />
      </Link>
    </div>
  </div>
);

const { shape, string, bool } = PropTypes;

WinnerCard.propTypes = {
  award: shape({
    name: string.isRequired,
    logo: string.isRequired,
  }).isRequired,
  winner: shape({
    name: string.isRequired,
    pathName: string.isRequired,
    logo: string,
  }).isRequired,
  featured: bool,
};

WinnerCard.defaultProps = {
  featured: false,
};

export default WinnerCard;
